import { StateCreator } from 'zustand'

import { ConnectionEntity } from '../types'
import { AvailableConnectionsEntity } from '../types/connections'

interface ConnectionsState {
  availableConnections: AvailableConnectionsEntity[]
  connections: ConnectionEntity[]
}

interface ConnectionsActions {
  addConnection: (connection: ConnectionEntity) => void
  deleteConnection: (id: string) => void
  setAvailableConnections: (conns: AvailableConnectionsEntity[]) => void
  setConnections: (conns: ConnectionEntity[]) => void
  updateConnection: (connection: ConnectionEntity) => void
}

export type ConnectionsSlice = ConnectionsState & ConnectionsActions

export const initialConnectionsState: ConnectionsState = {
  availableConnections: [],
  connections: [],
}

const createConnectionsSlice: StateCreator<ConnectionsSlice, [], [], ConnectionsSlice> = (
  set,
  get,
) => ({
  ...initialConnectionsState,
  addConnection: (newConnection) =>
    set((state) => ({ connections: [...state.connections, newConnection] })),
  deleteConnection: (id) =>
    set((state) => ({
      connections: state.connections.filter((connection) => connection.id !== id),
    })),
  setAvailableConnections: (availableConnections) => {
    const prevAvailableConnections = get().availableConnections
    if (JSON.stringify(prevAvailableConnections) !== JSON.stringify(availableConnections)) {
      set({ availableConnections })
    }
  },
  setConnections: (connections) => {
    const prevConnections = get().connections
    if (JSON.stringify(prevConnections) !== JSON.stringify(connections)) {
      set({ connections })
    }
  },
  updateConnection: (updatedConnection) =>
    set((state) => ({
      connections: state.connections.map((connection) =>
        connection.id === updatedConnection.id ? updatedConnection : connection,
      ),
    })),
})

export default createConnectionsSlice
